module.exports = __webpack_public_path__ + "img/HT01080-76.3f82bd74.jpg";